import {
  plateShadow,
  plateBase,
  plateTop,
  plateSubstrate,
  plateStripe,
  saucePlate,
  chopstickStand,
} from '@/assets/ui'
import { PlateConfig } from '@/components/DevTools/PlateEditor'

interface PlateProps {
  config: PlateConfig
}

export default function Plate({ config }: PlateProps) {
  return (
    <div className="absolute bottom-0 left-0 right-0 h-[120px] z-10">
      {/* Подложка под тарелкой (синяя полоса на всю ширину) */}
      <img 
        src={plateSubstrate} 
        alt="" 
        className="absolute left-0 right-0 w-full object-cover"
        style={{
          height: `${config.substrate.height}px`,
          bottom: `${config.substrate.bottom}px`,
        }}
        draggable={false}
      />
      
      {/* Чашечка для соуса (слева) */}
      <img 
        src={saucePlate} 
        alt="" 
        className="absolute z-10"
        style={{
          width: `${config.saucePlate.width}px`,
          left: config.saucePlate.left,
          bottom: `${config.saucePlate.bottom}px`,
          filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
        }}
        draggable={false}
      />
      
      {/* Подставка для палочек (справа, зеркально соуснице) */}
      <img 
        src={chopstickStand} 
        alt="" 
        className="absolute z-10"
        style={{
          width: `${config.saucePlate.width}px`,
          right: config.saucePlate.left,
          bottom: `${config.saucePlate.bottom}px`,
          filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
        }}
        draggable={false}
      />
      
      {/* Основная тарелка (по центру) */}
      <div 
        className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center"
        style={{ bottom: `${config.plate.bottom}px` }}
      >
        {/* Тень */}
        <img 
          src={plateShadow} 
          alt="" 
          className="absolute bottom-[-4px] opacity-50"
          style={{ width: `${config.plate.width * 0.65}px` }}
          draggable={false}
        />
        
        {/* Верхняя глянцевая часть */}
        <img 
          src={plateTop} 
          alt="" 
          className="relative z-10"
          style={{ width: `${config.plateTop.width}px` }}
          draggable={false}
        />
        
        {/* Основание */}
        <img 
          src={plateBase} 
          alt="" 
          style={{
            width: `${config.plateBase.width}px`,
            marginTop: `${config.plateBase.marginTop}px`,
          }}
          draggable={false}
        />
        
        {/* Чёрная полоска в нижней части тарелки */}
        <img 
          src={plateStripe} 
          alt="" 
          style={{
            width: `${config.plateStripe.width}px`,
            marginTop: `${config.plateStripe.marginTop}px`,
          }}
          draggable={false}
        />
      </div>
    </div>
  )
}

